import {
  DmsDownloadDto,
  DMSTokenResponseDto,
  DmsUrlResponseDto,
} from '@cratehackers/api-client';
import ApiService from './Api.service';

export class DmsService {
  public static async getAuthUrl(): Promise<string> {
    const { url } = await ApiService.getApiClient().dmsControllerGetAuthUrl();
    return url;
  }

  public static async exchangeDmsCode(
    code: string,
  ): Promise<DMSTokenResponseDto> {
    return await ApiService.getApiClient().dmsControllerExchange({
      dMSExchangeTokenDto: { code },
    });
  }

  public static async checkDmsStatus(): Promise<boolean> {
    const { loggedIn } = await ApiService.getApiClient().dmsControllerStatus();
    return loggedIn ? loggedIn : false;
  }

  public static async logoutDms() {
    await ApiService.getApiClient().dmsControllerLogout();
  }

  public static async getDmsDownloadUrl(
    mediaId: string,
  ): Promise<DmsUrlResponseDto> {
    const api = ApiService.getApiClient();
    const dto: DmsDownloadDto = { mediaId };

    try {
      return await api.dmsControllerGetDownloadUrl({ dmsDownloadDto: dto });
    } catch (error: any) {
      // Extract status code from API client error and rethrow with status
      const statusCode =
        error?.response?.status || error?.status || error?.code;
      const newError = new Error(error?.message || 'DMS download failed');
      (newError as any).status = statusCode;
      (newError as any).response = { status: statusCode };
      throw newError;
    }
  }

  public static async getDmsPreviewUrl(mediaId: string): Promise<string> {
    const api = ApiService.getApiClient();
    const dto: DmsDownloadDto = { mediaId };

    try {
      const previewDto = await api.dmsControllerGetPreviewUrl({
        dmsDownloadDto: dto,
      });
      return previewDto.url;
    } catch (error: any) {
      // Extract status code from API client error and rethrow with status
      const statusCode =
        error?.response?.status || error?.status || error?.code;
      const newError = new Error(error?.message || 'DMS preview failed');
      (newError as any).status = statusCode;
      (newError as any).response = { status: statusCode };
      throw newError;
    }
  }
}
